<template>
  <div
    class="upload-item"
    :class="{
      'is-enterprise': enterpriseMode,
      'is-enterprise-uploading': isEnterpriseUploading,
      'is-enterprise-upload-ready': isEnterpriseUploadReady,
      'is-enterprise-translating': isEnterpriseTranslating,
      'is-enterprise-translation-result': isEnterpriseTranslationResult,
    }"
  >
    <div class="left-item">
      <div class="left-item-icon">
        <span v-if="enterpriseMode" class="enterprise-file-icon">
          <WorkbenchIcon name="file-text" :size="17" />
        </span>
        <template v-else>
          <i class="iconfont icon-image icon-icon_pdf6"
            :style="{color:'#FF6666', backgroundColor:'rgba(255, 102, 102, 0.2)' }"
            v-if="item.type == 1 && item.status != 5" />
          <i class="iconfont icon-image icon-icon_zip6"
            :style="{color:'#FFB366', backgroundColor:'rgba(255, 179, 102, 0.2)'}"
            v-if="item.type == 2 && item.status != 5" />
          <i class="iconfont icon-image icon-icon_ppt6"
            :style="{color:'#FF6666', backgroundColor:'rgba(255, 102, 102, 0.2)'}"
            v-if="item.type == 3 && item.status != 5" />
          <i class="iconfont icon-image icon-icon_word6"
            :style="{color:'#2DA5FF', backgroundColor:'rgba(45, 165, 255, 0.2)'}"
            v-if="item.type == 4 && item.status != 5" />
          <i class="iconfont icon-image icon-icon_xlsl6"
            :style="{color:'#3DCF64', backgroundColor:'rgba(61, 207, 100, 0.2)'}"
            v-if="item.type == 5 && item.status != 5" />
          <i class="iconfont icon-image icon-icon_rar6"
            :style="{color:'#3DCF64', backgroundColor:'rgba(61, 207, 100, 0.2)'}"
            v-if="item.type == 6 && item.status != 5" />
          <i class="iconfont icon-image icon-icon_epub6"
            :style="{color:'#3DCF64', backgroundColor:'rgba(61, 207, 100, 0.2)'}"
            v-if="item.type == 7 && item.status != 5" />
          <i class="iconfont icon-image icon-icon_srt6"
            :style="{color:'#2DA5FF', backgroundColor:'rgba(45, 165, 255, 0.2)'}"
            v-if="item.type == 8 && item.status != 5" />
          <i class="iconfont icon-image icon-icon_txt6"
            :style="{color:'#3DCF64', backgroundColor:'rgba(61, 207, 100, 0.2)'}"
            v-if="item.type == 12 && item.status != 5" />
          <i class="iconfont icon-image icon-icon_png6"
            :style="{color:'#FF8D66', backgroundColor:'rgba(255, 141, 102, 0.2)'}"
            v-if="item.type == 9 && item.status != 5" />
          <i class="iconfont icon-image icon-icon_jpeg6"
            :style="{color:'#2DA5FF', backgroundColor:'rgba(45, 165, 255, 0.2)'}"
            v-if="item.type == 10 && item.status != 5" />
          <i class="iconfont icon-image icon-icon_jpg6"
            :style="{color:'#2DA5FF', backgroundColor:'rgba(45, 165, 255, 0.2)'}"
            v-if="item.type == 11 && item.status != 5" />

          <i class="iconfont icon-icon_fail"
            style="color: #E14C25; font-size: 25px;padding: 6px 6px; background-color: #F9DBD3; border-radius: 4px"
            v-if="item.status == 5" />
        </template>
      </div>
      <p class="left-title" style="margin-left: 10px">{{ item.name }}</p>
    </div>
    <div class="middle-item">

      <div class="statusClass" v-if="item.status == 2">

        <Progress :width="customwidth" :percent="100* item.progress" :stroke-width="customHeight"
          class="custom-progress" :show-info="!enterpriseMode"
          :stroke-color="enterpriseMode ? '#2B7DE9' : '#2590e1'" />

      </div>

      <div class="statusClass" v-if="item.status == 4">

        <div style="display: flex; flex-direction: row" v-if="!getBottomHiddenOrShow(item)">
          <!--          <i class="iconfont icon-icon_checkl success" style="font-size: 18px"/>-->
          <!--          <div class="title" style="font-size: 14px; color:#34A853; margin-left: 10px">{{ $t("uploadSuccess") }}</div>-->
        </div>
        <div class="translate" v-if="getLoadingHiddenOrShow(item, 0) || getLoadingHiddenOrShow(item, 3)">

          <Progress :width="customwidth" :percent="100* getTranslateRate(item)" :stroke-width="customHeight"
            class="custom-progress" :show-info="!enterpriseMode"
            :stroke-color="enterpriseMode ? '#2B7DE9' : '#2590e1'" />
          <span class="cancel-translate-btn" v-if="canShowCancel(item)" @click.stop="call('onCancelTranslate', item)">{{ $t('cancel_translate_btn') }}</span>
        </div>
        <div class="translate_free" v-if="getLoadingHiddenOrShow(item, 0) || getLoadingHiddenOrShow(item, 3)">
          <div class="status_free_view">
            <i class="iconfont icon-icon_History"></i>
            <span class="status_free_view_text">{{ $t('translateing') }}</span>
          </div>
        </div>
        <div class="translate" v-if="!props.translateResults[item.filename]">

          <Progress :width="customwidth" :percent="100* item.progress" :stroke-width="customHeight"
            class="custom-progress" :show-info="!enterpriseMode"
            :stroke-color="enterpriseMode ? '#2B7DE9' : '#2590e1'" />
          <!-- <i class="iconfont" v-if="item.pageNum" :class="`${ parseInt(item.pageNum * config.maybePdfPageChars) < userStore.getRoleCharacterByNum() ? 'icon-icon_check2' : 'icon-icon_fail1'}`" style="font-size: 18px;color: #34A853; margin-left: 5px;" :style="`color:${parseInt(item.pageNum * config.maybePdfPageChars) < userStore.getRoleCharacterByNum() ? '#34A853' : '#F09308'}`"/>
          <div v-if="item.pageNum" class="translate-title" style="font-size: 14px;margin-left: 5px" :style="`color:${parseInt(item.pageNum * config.maybePdfPageChars) < userStore.getRoleCharacterByNum() ? '#34A853' : '#F09308'}`">{{t("expect-char").replace("*", parseInt(item.pageNum * config.maybePdfPageChars).toLocaleString())}}  {{ parseInt(item.pageNum * config.maybePdfPageChars) > userStore.getRoleCharacterByNum() ? $t("un-supper-translate-file") : "" }}</div> -->

        </div>
        <div class="translate" v-if="getLoadingHiddenOrShow(item, 1)">
          <i class="iconfont icon-icon_check2 success" style="font-size: 18px" />
          <div class="title" style="font-size: 14px; color:#34A853; margin-left: 5px">{{ getTranslateStatusTitle(item)
            }}</div>
          <div class="title" style="font-size: 14px; color:#595959; margin-left: 10px" v-if="getFileCostCharsNum(item)">
            {{t("upload_item_char")}}:{{getFileCostCharsNum(item)}}</div>
        </div>
        <div class="translate" v-if="getLoadingHiddenOrShow(item, 2)">
          <i class="iconfont icon-icon_error_1 fail" style="font-size: 18px" />
          <div style="font-size: 14px; margin-left: 5px"
            :style="`color: ${getFileFailReasonTitle(item) == $t('translateFail') ? '#E14C25' : '#F09308'}`">
            {{getFileFailReasonTitle(item)}}</div>
        </div>
      </div>
      <WorkbenchIcon
        v-if="isEnterpriseUploadReady"
        name="circle-check"
        :size="16"
        class="enterprise-upload-success"
      />
    </div>
    <div class="right-item">
      <div class="right-item-web hidden-sm-only hidden-xs-only">
        <div class="btn" @click="(event)=>onPreview(event)"
          v-if="item.type != 7 && item.status == 4 && getLoadingHiddenOrShow(item, 1)">
          {{t("account_enterprise_permission_look")}}
        </div>
        <div class="btn"
          v-if="item.status == 4 && getLoadingHiddenOrShow(item, 1) && !getShowTry(item) && item.type != 1"
          @click="(event)=>onDownLoadFile(event, false)">
          {{t("account_enterprise_permission_download")}}
        </div>
        <el-popover ref="popoverChatRef" width="auto" trigger="click" popper-class="custom-chatPopover"
          v-if="item.type == 1">
          <template #reference>
            <div class="btn" v-if="item.status == 4 && getLoadingHiddenOrShow(item, 1) && !getShowTry(item)"
              @click="(event)=>onDownLoadFile(event, true)">
              {{t("account_enterprise_permission_download")}}
            </div>
          </template>
          <div style="flex-direction: column; display: flex; align-items: center; justify-content: center"
            v-if="getShowCompareFile()">
            <div class="chatDiv" style="margin-top: 5px" @click="((event)=>onDownLoadFile(event, false))">
              <div class="chat-title">{{ $t('download_file_btn1') }}</div>
            </div>
            <div class="chatDiv" style="margin-top: 20px" @click="((event)=>onDownloadCompareFile(event))">
              <div class="chat-title">{{$t('download_file_btn2')}}</div>
            </div>
          </div>
        </el-popover>
        <div class="btn"
          v-if="uploadCount == 1 && (item.status == 4 || item.status == 5) && getLoadingHiddenOrShow(item, 2)"
          @click="(event)=>onResetTranslateFile(event)">
          {{t("accountResetTranslate")}}
        </div>
        <div class="btn1" v-if="(item.status == 4 || item.status == 5) && !getLoadingHiddenOrShow(item, 0)"
          @click="(event)=>onDelete(event)">
          <WorkbenchIcon v-if="enterpriseMode" name="x" :size="15" />
          <i v-else class="iconfont icon-icon_error1" />
        </div>
      </div>
    </div>
  </div>
  <!-- <translateMenu ref="translateMenuRef" @download="handlerDownload" @delete="handlerDelete" @check="handlerCheck"
    :item="item" :translateResults="translateResults">
  </translateMenu>

  <DownloadCompareFileCom ref="downloadCompareFileRef" @downloadCompare="downloadCompare">
  </DownloadCompareFileCom>

  <DownloadBilingualHint :isOpen="isOpenBilingualShow" @confirm="BilingualConfirm" @close="closeConfirm">
  </DownloadBilingualHint> -->
</template>

<script lang="ts" setup>
// import translateMenu from '@/components/translateComponents/menu.vue'
// import DownloadCompareFileCom from '@/components/translateComponents/DownloadCompareFile.vue'
// const DownloadBilingualHint = defineAsyncComponent(() => import("~/components/common/DownloadBilingualHint.vue"))
import TranslateServer from '@/services/TranslateServer';
import Progress from '@/components/Progress/Progress.vue'
import WorkbenchIcon from '@/components/Workbench/WorkbenchIcon.vue'
import {computed, onMounted, defineEmits, nextTick, toRaw} from "vue";
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
import useUserStore from "@/store/modules/user";
import {storeToRefs} from "pinia";
import { useCancelEligibility } from "@/composables/useCancelEligibility";
// import { isMobileOrTablet} from '../../utils'

const router = useRouter()
const route = useRoute()
const userStore = useUserStore();
const {userInfo, token} = storeToRefs(userStore);
//item.status 1 检测中 2上传中 3计算字符中 4上传成功 5上传失败 6正常图标

let call = defineEmits(["onPreview", "onDelete", "onTry", "onOpenFile", "onDownLoadFile", "onResetTranslate", "onDownLoad", "onCancelTranslate"])
const {t} = useI18n()
let currentFileInfo = ref()
let popoverChatRef = ref()
const customHeight = ref<number>(16)
const customwidth = ref<number>(200)

const props = defineProps({
  item: {
    type: Object,
    default: () => ({})
  },
  translateResults: {
    type: Object,
    default: () => ({})
  },
  index: {
    type: Number,
    default: 0
  },
  uploadCount: {
    type: Number,
    default: 0
  },
  enterpriseMode: {
    type: Boolean,
    default: false
  }
})

const { canCancel } = useCancelEligibility()
// 只有 item.name 是带扩展名的原始文件名（TranslateUpload/index.vue:1286 赋 file.name，模板标题也用它）；
// item.filename 是服务端临时键 tmpFileName（后端取 blobFileName.split(".")[0] 或随机串），不含扩展名，只能当 map 的 key 用。
// freeTag 恒 0：企业上传两处请求都写死 freeTag: 0（TranslateUpload/index.vue:1236 / :1272）。
// bizTeamId 取当前用户：本会话上传的记录归属就是当前用户企业。这两个值不是从记录里读的，是本组件的已知近似。
const canShowCancel = (item: any) => {
  const r = props.translateResults[item.filename]
  if (!r || r.status !== 0 || !r.translateId) return false
  const ext = String(item.name || '').split('.').pop()?.toLowerCase() ?? ''
  // 上传区的任务都是当前用户自己的；后端另有 sessionUid == record.userId 的越权拦截
  return canCancel({ operateStatus: 0, userId: userInfo.value?.id, freeTag: 0, fileType: ext, bizTeamId: userInfo.value?.bizTeamId ?? null })
}
const currentTranslationResult = computed(() => props.translateResults?.[props.item?.filename])
const currentTranslationStatus = computed(() => currentTranslationResult.value?.status)
const isEnterpriseUploading = computed(() => (
  props.enterpriseMode
  && props.item?.status == 2
))
const isEnterpriseUploadReady = computed(() => (
  props.enterpriseMode
  && props.item?.status == 4
  && !currentTranslationResult.value
))
const isEnterpriseTranslating = computed(() => (
  props.enterpriseMode
  && props.item?.status == 4
  && (currentTranslationStatus.value == 0 || currentTranslationStatus.value == 3)
))
const isEnterpriseTranslationResult = computed(() => (
  props.enterpriseMode
  && props.item?.status == 4
  && (currentTranslationStatus.value == 1 || currentTranslationStatus.value == 2)
))

const getLoadingHiddenOrShow = (item, status) => {
  let isTranslate = false
  if (props.translateResults[item.filename] && props.translateResults[item.filename].status == status) {
    console.log("getLoadingHiddenOrShow===", props.translateResults[item.filename])
    isTranslate = true
  }
  return isTranslate
}

const getBottomHiddenOrShow = (item) => {
  let isTranslate = false
  if (props.translateResults[item.filename] && props.translateResults[item.filename].status >= 0) {
    isTranslate = true
  }
  return isTranslate
}

const getFileCostCharsNum = (item) => {
  if (props.translateResults[item.filename]) {
    return props.translateResults[item.filename].costCharsNum
  }
  return null
}

const getShowTry = (item) => {
  let tryOcrFlag = false
  if (props.translateResults[item.filename]) {
    tryOcrFlag = props.translateResults[item.filename].tryOcrFlag
    if (token.value && (userInfo.value.vipLevel > 0 || userInfo.value.validWordsForBag > 0))  {
      tryOcrFlag = false
    }
  }
  return tryOcrFlag
}

const getFileFailReasonTitle = (item) => {
  if (props.translateResults[item.filename] && props.translateResults[item.filename].failReason) {
    let failReason = props.translateResults[item.filename].failReason
    if (failReason == 1) { // 日不足
      return t("upload_error_day")
    }else if (failReason == 2) { // 月不足
      return t("upload_error_month")
    }else if (failReason == 3) { //纯图片不支持
      return userInfo.value.vipLevel == 0 ? t("pure-image") : t("pure-image-vip")
    }else if (failReason == 4) { // 已取消
      return t("cancel_record_status")
    }
  }
  return t("translateFail")
}

const getTranslateStatusTitle = (item) => {
  if (props.translateResults[item.filename] && props.translateResults[item.filename].status === 0) {
    return t("translateing") + props.translateResults[item.filename].rate
  }else if (props.translateResults[item.filename] && props.translateResults[item.filename].status === 1) {
    let failReason = props.translateResults[item.filename].failReason ?? 0
    return failReason == 0 ? t("translateSuccessful") : t("upload-item-part-success")
  }else if (props.translateResults[item.filename] && props.translateResults[item.filename].status === 2) {
    let failReason = props.translateResults[item.filename].failReason
    return failReason == 4 ? t("cancel_record_status") : t("translateFail")
  }
  return "0%"
}

const getTranslateRate = (item) => {
  if (props.translateResults[item.filename] && (props.translateResults[item.filename].status === 0 || props.translateResults[item.filename].status === 3)) {
    let rate = props.translateResults[item.filename].rate ? parseInt(props.translateResults[item.filename].rate, 10) / 100 : 0
    console.log("getTranslateRate===", rate)
    return rate
  }
  return 0
}

const getShowCompareFile = () => {
  console.log("getShowCompareFile", currentFileInfo.value)
  let showCompareFlag = currentFileInfo.value && currentFileInfo.value.finishFlag == 1 && currentFileInfo.value.remark && currentFileInfo.value.remark.compareFileBlobName ? true : false
  return showCompareFlag
}

function onPreview(e: Event) {
  e.stopPropagation()
  if (getLoadingHiddenOrShow(props.item, 1)) {
    // 如果下载完成了
    call("onOpenFile", props.index, props.item)
    return
  }
  call("onPreview", props.index)
}

function onDelete(e: Event) {
  e.stopPropagation()
  call("onDelete", props.index)
}

function onDownLoadFile(e: Event, isRequest: Boolean) {
  e.stopPropagation()
  if (isRequest && !currentFileInfo.value) {
    let fileId = props.translateResults[props.item.filename].translateId
    TranslateServer.getRequestOperateRecordId({thisId: fileId}).then((data) => {
      console.log("onDownLoadFile ==", data)
      if (data.code == "1") {
        currentFileInfo.value = data.data
        if (data.data.remark) {
          currentFileInfo.value.remark = JSON.parse(data.data.remark)
        }
        if (data.data.operateTag) {
          currentFileInfo.value.operateTag = JSON.parse(data.data.operateTag)
        }
        if (data.data.translateJson) {
          currentFileInfo.value.translateJson = JSON.parse(data.data.translateJson)
        }
      }
      if (!getShowCompareFile()) {
        call("onDownLoad", props.index, props.item)
        popoverChatRef.value && popoverChatRef.value.hide()
      }
    })
    return
  }
  if (isRequest) {
    if (!getShowCompareFile()) {
      call("onDownLoad", props.index, props.item)
    }
    return
  }
  call("onDownLoad", props.index, props.item)
  popoverChatRef.value && popoverChatRef.value.hide()
}

function onDownloadCompareFile(e: Event) {
  // if (!BilingualChecked.value) {
  //   isOpenBilingualShow.value = true
  //   return;
  // }
  e.stopPropagation()
  call("onDownLoad", props.index, props.item, currentFileInfo.value)
  popoverChatRef.value && popoverChatRef.value.hide()
}

function onResetTranslateFile(e: Event) {
  e.stopPropagation()
  call("onResetTranslate", props.index, props.item)
}

const openOperations = (e) => {  
  e.stopPropagation(); // 阻止事件冒泡
  
  // if(translateMenuRef.value){
  //   translateMenuRef.value.openDrawer()
  // }
}

onMounted(()=>{

})

</script>

<style lang="scss" scoped>
@use './index.scss' as *;

.cancel-translate-btn {
  flex: 0 0 auto;
  font-size: 12px;
  line-height: 20px;
  color: #2590E1;
  cursor: pointer;
  margin-left: 8px;
  white-space: nowrap;
  &:hover {
    text-decoration: underline;
  }
}
</style>
